// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"fb701844","199":"eecad4f6","308":"d0179176","321":"c5c96151","548":"908ddb69","957":"a7a37100","975":"66ee671a"}[chunkId] + ".chunk.js";
};